export const EventClosedMessage = 'Online registration for this event has concluded, but we\'d still love for you to join us. To register, please email the event organizer listed on the left of the page.';

export const AlreadyRegistered = 'Thank you for your response. You have already registered for this event.';

export const AlreadyDeclined = 'Thank you for your response. You have already decline for this event.';

export const Registered = 'You have successfully registered for this event. Please look for a confirmation email arriving shortly. Thanks for your interest!';

export const Declined = 'Sorry you cannot make it. Thank you for your response';

export const NotYou = "No further action is required.";

export const EventExpiredTitle = 'Sorry, but the event you are looking for cannot be found.';

export const EventExpiredMsg = 'If you have any questions, please contact the event organizer directory.'

export const UnsubscribeSuccessTitle = 'Unsubscribe Request Successful';

export const UnsubscribeSuccess = 'It will take 2-3 business days to unsubscribe from our email list.';

export const UnsubscribeTitle = 'Unsubscribe Request Form';

export const Unsubscribe = 'Before you  unsubscribe, is this your email?';

export const UnsubscribeMailNotFound = 'Your email address has been already unsubscribed'

export const ErrEmail = 'Please enter proper email address.';

export const ZeroGuid = '00000000-0000-0000-0000-000000000000';

export const SystemMaintenenceTitle = "We'll be back soon!";

export const SystemMaintenenceMsg = "Sorry for the inconvenience. We are performing some maintenance at the moment. Please come back later.";
